export default __webpack_public_path__ + "static/media/avatar.b7b84a88.jpg";